module.exports = __webpack_public_path__ + "static/media/FCCTrainingGuide.e07075e7.pdf";